var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "android"
  }, /*#__PURE__*/React.createElement("g", {
    id: "android_2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.77117 3.21059C8.36773 2.87739 9.05522 2.6875 9.78706 2.6875C10.5189 2.6875 11.2064 2.87739 11.8029 3.21059L12.2394 2.77411C12.3549 2.65863 12.5421 2.65863 12.6576 2.77411C12.7731 2.8896 12.7731 3.07684 12.6576 3.19232L12.3073 3.54269C13.2922 4.29951 13.9271 5.48939 13.9271 6.82756H5.647C5.647 5.48939 6.28188 4.29951 7.26685 3.54269L6.91649 3.19232C6.801 3.07684 6.801 2.8896 6.91649 2.77411C7.03197 2.65863 7.21921 2.65863 7.3347 2.77411L7.77117 3.21059ZM8.60418 5.05325C8.60418 5.37989 8.33939 5.64469 8.01275 5.64469C7.68611 5.64469 7.42131 5.37989 7.42131 5.05325C7.42131 4.72661 7.68611 4.46181 8.01275 4.46181C8.33939 4.46181 8.60418 4.72661 8.60418 5.05325ZM11.5614 5.64469C11.888 5.64469 12.1528 5.37989 12.1528 5.05325C12.1528 4.72661 11.888 4.46181 11.5614 4.46181C11.2347 4.46181 10.9699 4.72661 10.9699 5.05325C10.9699 5.37989 11.2347 5.64469 11.5614 5.64469Z",
    fill: "#87C527"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.28125 8.30615C3.28125 7.81619 3.67844 7.419 4.16841 7.419C4.65837 7.419 5.05556 7.81619 5.05556 8.30615V11.8548C5.05556 12.3447 4.65837 12.7419 4.16841 12.7419C3.67844 12.7419 3.28125 12.3447 3.28125 11.8548V8.30615Z",
    fill: "#87C527"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.42131 15.1077V17.1777C7.42131 17.6677 7.8185 18.0649 8.30847 18.0649C8.79843 18.0649 9.19562 17.6677 9.19562 17.1777V15.1077H10.3785V17.1777C10.3785 17.6677 10.7757 18.0649 11.2657 18.0649C11.7556 18.0649 12.1528 17.6677 12.1528 17.1777V15.1077H12.7442C13.3975 15.1077 13.9271 14.5781 13.9271 13.9248V7.419H5.647V13.9248C5.647 14.5781 6.17659 15.1077 6.82987 15.1077H7.42131Z",
    fill: "#87C527"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5186 8.30615C14.5186 7.81619 14.9157 7.419 15.4057 7.419C15.8957 7.419 16.2929 7.81619 16.2929 8.30615V11.8548C16.2929 12.3447 15.8957 12.7419 15.4057 12.7419C14.9157 12.7419 14.5186 12.3447 14.5186 11.8548V8.30615Z",
    fill: "#87C527"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.5228aeb61a30ce90a97596ca227a7ae8.svg";
export { ForwardRef as ReactComponent };